import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import ReferenceContactFormModal from './ReferenceContactFormModal';
import Pagination from './Pagination';
import usePageSize from '../../utils/usePageSize';

import { ta, taf } from '../../i18n/adminT';
export default function ReferenceContactsManager() {
  const [contacts, setContacts] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const { pageSize, pageSizeRef, setPageSize } = usePageSize('reference-contacts');
  const [search, setSearch] = useState('');
  const [error, setError] = useState('');
  // undefined = popup chiuso, null = nuova persona, oggetto = modifica
  const [formContact, setFormContact] = useState(undefined);

  const load = async (q = search, p = page) => {
    const res = await api.getReferenceContacts(q, p, pageSizeRef.current);
    // Eliminata l'ultima riga dell'ultima pagina: si torna alla precedente
    if (res.data.length === 0 && p > 1 && res.total > 0) {
      return load(q, p - 1);
    }
    setContacts(res.data);
    setTotal(res.total);
    setPage(p);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load('', 1); }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    load(search, 1);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    load(search, 1);
  };

  const handleDelete = async (contact) => {
    if (!window.confirm(taf('Eliminare "{nome}" dalle persone di riferimento?', { nome: `${contact.nome} ${contact.cognome}` }))) return;
    setError('');
    try {
      await api.deleteReferenceContact(contact.id);
      await load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <h1 className="admin-page-title">{ta('Persone di riferimento')}</h1>
      <p className="admin-page-subtitle">
        {ta('Anagrafica interna (nome, cognome, email) usata come persona di riferimento in fase di registrazione.')}
      </p>

      {error && <div className="form-error">{error}</div>}

      <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginBottom: 18 }}>
        <form onSubmit={handleSearch}>
          <input
            className="search-input"
            placeholder={ta('Cerca per nome, cognome o email…')}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: 280 }}
          />
        </form>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => setFormContact(null)}
          style={{ width: 'auto', padding: '10px 20px', marginTop: 0 }}
        >
          {ta('+ Aggiungi nuovo')}
        </button>
      </div>

      <div className="admin-card">
        <table className="admin-table">
          <thead>
            <tr>
              <th>{ta('Nome')}</th>
              <th>{ta('Cognome')}</th>
              <th>{ta('Email')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((c) => (
              <tr key={c.id}>
                <td>{c.nome}</td>
                <td>{c.cognome}</td>
                <td>{c.email}</td>
                <td style={{ display: 'flex', gap: 6 }}>
                  <button className="btn-ghost btn" style={{ width: 'auto', padding: '6px 10px' }} onClick={() => setFormContact(c)}>{ta('Modifica')}</button>
                  <button className="btn-ghost btn" style={{ width: 'auto', padding: '6px 10px', color: 'var(--clay-red-dark)' }} onClick={() => handleDelete(c)}>{ta('Elimina')}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {contacts.length === 0 && <p style={{ color: 'var(--muted-text)', padding: '16px 0 0' }}>{ta('Nessuna persona di riferimento trovata.')}</p>}

        <Pagination
          page={page}
          totalPages={Math.max(1, Math.ceil(total / pageSize))}
          onChange={(p) => load(search, p)}
          total={total}
          pageSize={pageSize}
          onPageSizeChange={handlePageSizeChange}
        />
      </div>

      {formContact !== undefined && (
        <ReferenceContactFormModal
          contact={formContact}
          onClose={() => setFormContact(undefined)}
          onSaved={load}
        />
      )}
    </div>
  );
}
